import React, { ComponentType } from "react";

function withErrorCatch<T>(Component: ComponentType<T>) {
  return (hocProps: any) => {
    try {
      if (!hocProps) return <></>;
      if (!hocProps?.fields) return <></>;
      return <Component {...hocProps} />;
    } catch (error) {
      console.log((error as Error)?.stack);
      return <></>;
    }
  };
}

export default withErrorCatch;
